module.exports = __webpack_public_path__ + "img/step2.2b55a143.png";